import { useEffect, useRef, useState } from "react";
import { fontObject } from "app/utils/theme";
import { get } from "lodash";
import { getFieldStyles } from "app/utils/utils";
import styled from "styled-components";

const TextArea = ({ data }) => {
  const { onChange, placeholder, border } = data;

  // If external value changes, update the local value
  const externalValue = get(data, "value", "");
  useEffect(() => {
    setLocalValue(externalValue);
  }, [externalValue]);

  const [localValue, setLocalValue] = useState(externalValue);

  const debounceTimerRef = useRef(null);

  // Clean up timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  const fontStyle = get(data, "fontStyle", "bodyMd");
  const styleObject = get(fontObject, fontStyle);

  let backgroundColor = data.backgroundColor || data.background;

  return (
    <StyledTextArea
      onKeyDown={(e) => e.stopPropagation()}
      {...styleObject}
      {...data}
      defaultValue={undefined}
      value={localValue}
      placeholder={placeholder}
      disabled={data.disabled}
      border={border}
      minHeight={data.minHeight}
      maxLength={data.maxLength}
      background={backgroundColor}
      onChange={(e) => {
        const newValue = e.target.value;

        // Update local value immediately
        setLocalValue(newValue);

        // Clear any existing timer
        if (debounceTimerRef.current) {
          clearTimeout(debounceTimerRef.current);
        }

        // Set a new timer to call onChange after 200ms
        debounceTimerRef.current = setTimeout(() => {
          onChange(newValue);
        }, 200);
      }}
    />
  );
};

export default TextArea;

const StyledTextArea = styled.textarea`
  ${(p) => getFieldStyles(p)};
  min-height: ${(p) => p.minHeight || "auto"};
  font-family: ${(p) => (p.monospace ? "monospace" : "inherit")};
  resize: ${(p) => p.resize || "vertical"};
  &:focus {
    outline: none;
  }
  ${(p) =>
    p.placeholderColor &&
    `
    ::placeholder {
      color: ${p.placeholderColor};
    }
    
    ::-ms-input-placeholder { /* Edge 12 -18 */
    color: ${p.placeholderColor};
    }
  `}
`;
